
import "../DropLoginDashboard/styles.css";
import "./styles.css";
//import "../Navbar/styles.css";

import DropLoginDashboard from "../DropLoginDashboard";
import FreePlanBadge from "../FreePlanBadge";

function Navbar() {
  return (
    <div className="easyvog-navbar">
      <nav className="easyvog-nav">
        <div className="container">
          <div id="mainListDiv" className="main_list">
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', width: '100%' }}>
              <div style={{ flex: 1 }}>
                <FreePlanBadge />
              </div>
              <DropLoginDashboard />
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
